<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
      </span>
      <select
        class="filter-item__select"
        v-model="querytype"
        @change="searchFeePlease"
      >
        <option :value="'全部'">全部</option>
        <option :value="'部门'">部门</option>
        <option :value="'报销人'">报销人</option>
      </select>
    </div>

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="weui-cells" v-if="querytype == '部门' && result.details">
      <department-field
        :label="'部门名称'"
        v-model="fp_department"
        @select="searchFeePlease"
      />
    </div>

    <div class="weui-cells" v-if="querytype == '报销人' && result.details">
      <employee-field
        :label="'报销人名称'"
        v-model="fp_pleaseman"
        @select="searchFeePlease"
      />
    </div>

    <div class="list-box" v-if="result.details">
      <div class="weui-cells">
        <div class="weui-cell" v-for="(item, index) in list" :key="index">
          <div class="weui-cell__bd">
            <p>{{ item.text }}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{ item.amount }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="list-empty" v-if="!result.details">暂无数据</div>
  </div>
</template>

<script>
import DepartmentField from "@/components/field/DepartmentField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    DepartmentField,
    EmployeeField,
  },
  data() {
    let year = new Date().getFullYear();

    return {
      result: [],
      list: [],
      year,
      querytype: "全部",
      querytypeObj: {
        全部: "detail",
        部门: "dept",
        报销人: "seller",
      },
      fp_department: "",
      fp_pleaseman: "",
      chart: null,
    };
  },
  mounted() {
    this.searchFeePlease();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    searchFeePlease() {
      var me = this;

      let params = {
        querytype: me.querytypeObj[me.querytype],
        year: me.year,
      };
      if (me.querytype == "部门" && me.fp_department) {
        params.con = `fp_department like '%${me.fp_department}%'`;
      } else if (me.querytype == "报销人" && me.fp_pleaseman) {
        params.con = `fp_pleaseman like '%${me.fp_pleaseman}%'`;
      }

      me.$loading({
        url: "/api/finance/feestatistics/getFeePlease",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          if (me.result && me.result.monthitems) {
            me.initChart(me.deal(me.result.monthitems));
          } else {
            me.chart.clear();
          }

          me.initList();
        } else {
          me.$router.push({
            name: "Error",
            params: { message: res.message, code: res.code },
          });
        }
      });
    },
    initList() {
      let data = this.result.details[0],
        arr = [];

      if (!data) {
        this.list = [];
        return;
      }

      for (let i = 0; i < 12; i++) {
        arr[i] = {
          text: i + 1 + "月",
          amount: data["amount" + (i + 1)] || 0,
        };
      }
      arr[12] = {
        text: "本年累计",
        amount: data["amount"],
      };

      this.list = arr;
    },
    deal(data) {
      if (!data) return;

      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "金额", value: 0 },
        { index: 12, type: "金额", value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          text: textArr[i],
          type: "金额",
          index: i,
          value: data[i]?.amount || 0,
        });
      }
      return arr;
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "金额") {
            return "#2eadf5";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });
      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = [];
      for (let i = year - 20; i <= year; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        defaultValue: [year],
        onConfirm: function (r) {
          me.year = r[0].value;
          me.searchFeePlease();
        },
      });
    },
  },
};
</script>

<style scoped>
.list-empty {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  background: #fff;
  color: #8b8b8b;
  font-size: 12px;
}
.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
  position: relative;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.canvas-box {
  /* width: 100%;
  height: 100%; */
  background: var(--weui-BG);
}

.list-box {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-box-nav {
  width: 100%;
  padding: 10px 10px 0;
  box-sizing: border-box;
  font-size: 13px;
  color: var(--weui-FG);
  display: flex;
  justify-content: space-between;
}
@media screen and (min-width: 500px) {
  .filter-bar {
    padding: 6px 0 2px 0;
  }
  
}
</style>